import { render, staticRenderFns } from "./GrantsListWidget.vue?vue&type=template&id=2fc985b7"
import script from "./GrantsListWidget.vue?vue&type=script&lang=js"
export * from "./GrantsListWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports